import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'
import GettingStarted from '@segment/templates/GettingStarted'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import TakeAProactiveApproach from './components/TakeProactiveApproach'
import CreateYourDynamicData from './components/CreateYourDynamicData'
import ManageYourRiskExposure from './components/ManageYourRiskExposure'
import StreamlineCompliance from './components/StreamlineCompliance'
import Testimonial from './components/Testimonial'
import FaqSection from './components/FaqSection'

import ogImagePng from './assets/OgPrivacyPortal.png'

const copy = {
  heading: `Ready for proactive privacy management?`,
  description: `Learn how Segment can help you protect your customers' privacy.`,
}

const PrivacyPortalView = () => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Privacy Portal: Data Privacy Management Tool | Twilio Segment"
        pageDescription="Empower your organization with Segment Privacy Portal, the leading data privacy management software. Ensure real-time visibility and automate the protection of your customers' data effortlessly."
        pageOG={ogImagePng}
      >
        <Navigation />
        <Hero />
        <main>
          <TakeAProactiveApproach />
          <CreateYourDynamicData />
          <ManageYourRiskExposure />
          <StreamlineCompliance />
          <Testimonial />
          <FaqSection />
          <GettingStarted heading={copy.heading} description={copy.description} />
        </main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

export default PrivacyPortalView
